import {Component, Injector, TemplateRef, ViewChild} from '@angular/core';
import {BlockBaseComponent} from "../block-base/block-base.component";
import {TranslocoService} from "@ngneat/transloco";
import {LocalStoreService, StoreSelectorsService} from "../../../../services";
import {MatDialog} from "@angular/material/dialog";
import {TouchLib} from "../../touch/touchLib";

@Component({
    selector: 'app-scene-block-label',
    templateUrl: './block-label.component.html',
    styleUrls: ['./block-label.component.scss']
})
export class BlockLabelComponent extends BlockBaseComponent {

    @ViewChild("pricingModal", {read: TemplateRef}) pricingModal: TemplateRef<any>;
    // @ViewChild('fontLoader', {static: false}) fontSelector: FontSelectorComponent;

    fontsPreviewed: Array<string> = [];

    // m_fontScene: Array<any> = [];
    // pricingModalDiag;
    // totalFontsToPreview = 0;
    // httpRequests = [];

    constructor(
        private translocoService: TranslocoService,
        public override storeSelector: StoreSelectorsService,
        public override dialog: MatDialog,
        protected override localStoreService: LocalStoreService,
        private injector: Injector
    ) {
        super(storeSelector, dialog, localStoreService);
    }

    override submit(formValues) {
        // formValues.Text = _.escape(formValues.Text);
        // formValues.Text = formValues.Text.replace(/</ig, '&lt;').replace(/>/ig, '&gt;').replace(/&/ig, '&amp;');
        // formValues.Text = formValues.Text.replace(/'/ig, '`');
        if (Array.isArray(formValues.Text)) {
            return super.submit(formValues);
        } else {
            return super.submit({Text: [formValues.Text]});
        }
    }

    override componentInit() {
        super.componentInit();
    }

    override componentStoreUpdates() {
        super.componentStoreUpdates();
        super.initApplyStoreToDynamic(true);
    }


    override initRegisterDynamic() {
        this.uiConfigInit = [
            {
                type: "input",
                value: '',
                label: this.translocoService.translate('general.displayedText', {}, this.translocoService.getActiveLang()),
                inputType: "textarea",
                name: "Text",
                restrictChar: 'basic0',
                storePath: 'Data[0].Label[0].Text'
            }
        ];
        this.uiConfigInit = this.appendGpu(this.uiConfigInit);
    }

    /**
     * Touch action handler - delegates to TouchLib
     */
    public override onTouchAction() {
        if (!this.sceneId || !this.dialog || !this.injector) return;
        TouchLib.handleTouchAction(this.sceneId, this.dialog, this.injector);
    }
}

